import flatpickr from "flatpickr";
import { Campground_Data, Trip_Cluster_v2, Trip_leg_v2, Trip_v2 } from "../util/tripPlanner_types";
import { days_to_ms, get_date_ignoreTimezone, ms_to_days } from "../util/general_util";
import { getTripHTML, setStayDates, setStopDates } from "./api_utils";
import { get_stop_from_stopID } from "./util/helper_functions";

function order_stays_by_dates(stop:Trip_Cluster_v2) {
    const preSortOrder=JSON.stringify(stop.selectedCamps.map(camp=>camp.camp.campID))
    stop.selectedCamps.sort((a,b) => {
        if (a.s_date === undefined) {
			return 1;
		};
		if (b.s_date === undefined) {
			return -1;
		};
		return a.s_date?.getTime() - b.s_date?.getTime()
    });
    const postSortOrder=JSON.stringify(stop.selectedCamps.map(camp=>camp.camp.campID));
    return preSortOrder != postSortOrder;
};

function get_closest_end_date(legIndex:number, stopIndex:number, stayIndex:number|null):Date|null {
    const legs = window.tripPlannerCurrentTrip.legs;
    for (let i:number = legIndex; i >= 0; i--) {
        let startStopIndex:number;
        if (i == legIndex)  {
            startStopIndex = stopIndex;
        } else {
            startStopIndex = legs[i].clusters.length - 1;
        };

        for (let j:number = startStopIndex; j >= 0; j--) {
            const stop = legs[i].clusters[j];
            if (stop.selectedCamps.length > 0) {
                let startStayIndex:number;
                if (i == legIndex && j == stopIndex && stayIndex != null && stayIndex > 0) {
                    startStayIndex = stayIndex - 1;
                } else {
                    startStayIndex = stop.selectedCamps.length - 1;
                };
                for (let k:number = startStayIndex; k >= 0; k--) {
                    if (stop.selectedCamps[k].s_date && stop.selectedCamps[k].numNights != null && stop.selectedCamps[k].numNights != undefined) {
                        return new Date(stop.selectedCamps[k].s_date.getTime() + days_to_ms(stop.selectedCamps[k].numNights));
                    };
                };

            } else if (stop.s_date && stop.numNights != null && stop.numNights != undefined) {
                if (! (i==legIndex && j==stopIndex)) {
                    return new Date(stop.s_date.getTime() + days_to_ms(stop.numNights));
                };
            };
        };
    };

    return null;
};

function handle_stopDateChange(selectedDates: Array<Date>, dateStr: string, instance: any) {
    const stopID = instance.input.getAttribute("stopID");
    const stopData = get_stop_from_stopID(stopID, window.tripPlannerCurrentTrip);
    if (stopData == null) return;
    const stop = stopData.stop;
    const legIndex = stopData.legIndex;
    const stopIndex = stopData.stopIndex;

    let s_date = selectedDates[0];
    let e_date = selectedDates.length > 1? selectedDates[1]: null;

    //convert dates to same date but UTC+0
    const month = s_date.getMonth();
    const day = s_date.getDate();
    const year = s_date.getFullYear();
    // s_date = new Date(Date.UTC(year, month, day));
    // if (e_date) {
    //     const month = e_date.getMonth();
    //     const day = e_date.getDate();
    //     const year = e_date.getFullYear();
    //     e_date = new Date(Date.UTC(year, month, day));
    // };

    stop.s_date = s_date;
    if (selectedDates.length > 1) stop.numNights = ms_to_days(e_date.getTime() - s_date.getTime());
    else stop.numNights = 0;

    $(instance.input).find("[select-dates-text]").remove();
    $(`[stop-date-display][stopID="${stopID}"]`).text(dateStr);

    $("[stop-date-display]").off("click");
    $("[stop-date-display]").on("click", function() {
        const stopID:string = this.getAttribute("stopID");
        $(`[stop-date-selector][stopID="${stopID}"]`).trigger("click");
    });

    setStopDates(stop, legIndex, stopIndex);

    show_dates_warnings(window.tripPlannerCurrentTrip);
};

function handle_stayDateChange(selectedDates: Array<Date>, dateStr: string, instance: any) {
    const campID:number = parseInt(instance.input.getAttribute("campID"));
    const stopID = instance.input.getAttribute("stopID");
    const stopData = get_stop_from_stopID(stopID, window.tripPlannerCurrentTrip);
    if (stopData == null) return;
    const stop = stopData.stop;
    const legIndex = stopData.legIndex;
    const stopIndex = stopData.stopIndex;

    let stay:Campground_Data|null = null;
    for (let i:number = 0; i < stop.selectedCamps.length; i++) {
        if (stop.selectedCamps[i].camp.campID == campID) {
            stay = stop.selectedCamps[i];
            break;
        };
    };
    if (stay === null) return;

    let s_date = selectedDates[0];
    let e_date = selectedDates.length > 1? selectedDates[1]: null;

    //convert dates to same date but UTC+0
    const month = s_date.getMonth();
    const day = s_date.getDate();
    const year = s_date.getFullYear();
    // s_date = new Date(Date.UTC(year, month, day));
    // if (e_date) {
    //     const month = e_date.getMonth();
    //     const day = e_date.getDate();
    //     const year = e_date.getFullYear();
    //     e_date = new Date(Date.UTC(year, month, day));
    // };

    stay.s_date = s_date;
    if (selectedDates.length == 1) return;
    stay.numNights = ms_to_days(e_date.getTime() - s_date.getTime());

    $(instance.input).find("[select-dates-text]").remove();
    $(`[stay-date-display][stopID="${stopID}"][campID="${campID}"]`).text(dateStr);

    $("[stay-date-display]").off("click");
    $("[stay-date-display]").on("click", function() {
        const stopID:string = this.getAttribute("stopID");
        const campID:number = parseInt(this.getAttribute("campID"));
        $(`[stay-date-selector][stopID="${stopID}"][campID="${campID}"]`).trigger("click");
    });

    setStayDates(stay, legIndex, stopIndex);

    const orderChanged:boolean = order_stays_by_dates(stop);

    if (orderChanged)  {
        getTripHTML(window.tripPlannerCurrentTrip).then(html => {
            window.tripPlannerCurrentTrip.stopListHTML = html;
            document.dispatchEvent(new CustomEvent("trip.html.updated"));
            document.dispatchEvent(new CustomEvent("directionsUpdateNeeded"));
        });
    };

    show_dates_warnings(window.tripPlannerCurrentTrip);
};

function handle_stopDateOpen(selectedDates: Array<Date>, dateStr: string, instance: any) {
    if (selectedDates.length > 0) return;
    const stopID = instance.input.getAttribute("stopID");
    const stopData = get_stop_from_stopID(stopID, window.tripPlannerCurrentTrip);
    if (stopData == null) return;
    const stop = stopData.stop;
    const legIndex = stopData.legIndex;
    const stopIndex = stopData.stopIndex;

    const d:Date|null = get_closest_end_date(legIndex, stopIndex, null);
    if (d != null) instance.setDate([d,d]);
};

function handle_stayDateOpen(selectedDates: Array<Date>, dateStr: string, instance: any) {
    if (selectedDates.length > 0) return;

    const stopID = instance.input.getAttribute("stopID");
    const stopData = get_stop_from_stopID(stopID, window.tripPlannerCurrentTrip);
    if (stopData == null) return;
    const stop = stopData.stop;
    const legIndex = stopData.legIndex;
    const stopIndex = stopData.stopIndex;

    const campID:number = parseInt(instance.input.getAttribute("campID"));

    let stayIdx:number|null = null;
    for (let i:number = 0; i < stop.selectedCamps.length; i++) {
        if (stop.selectedCamps[i].camp.campID == campID) {
            stayIdx = i;
            break;
        };
    };
    if (stayIdx == null) return;

    const d:Date|null = get_closest_end_date(legIndex, stopIndex, stayIdx);
    if (d != null) instance.setDate([d,d]);

};

export function init_date_pickers() {
    $("[stop-date-selector]").each(function(idx,el:HTMLElement) {
        const stopID = el.getAttribute("stopID");
        const stopData = get_stop_from_stopID(stopID, window.tripPlannerCurrentTrip);
        if (stopData == null) return;
        const stop = stopData.stop;

        if (stop.s_date) stop.s_date = get_date_ignoreTimezone(stop.s_date);
        const fp_config:any = {
            mode: "range",
            dateFormat: "m/d/Y",
            onOpen: handle_stopDateOpen,
            onChange: handle_stopDateChange
        };

        if (stop.s_date) {
            if (stop.numNights) {
                const e_date = new Date(stop.s_date.getTime() + days_to_ms(stop.numNights));
                fp_config.defaultDate = [stop.s_date,e_date];
            } else {
                fp_config.defaultDate = [stop.s_date]
            }
        }

        const fp = flatpickr(el, fp_config);
    });

    $("[stay-date-selector]").each(function(idx,el:HTMLElement) {
        const stopID = el.getAttribute("stopID");
        const stopData = get_stop_from_stopID(stopID, window.tripPlannerCurrentTrip);
        if (stopData == null) return;
        const stop = stopData.stop;

        const campID:number = parseInt(el.getAttribute("campID"));

        let stay:Campground_Data|null = null;
        for (let i:number = 0; i < stop.selectedCamps.length; i++) {
            if (stop.selectedCamps[i].camp.campID == campID) {
                stay = stop.selectedCamps[i];
                break;
            };
        };
        if (stay === null) return;
        if (stay.s_date) stay.s_date = get_date_ignoreTimezone(stay.s_date);

        const fp_config:any = {
            mode: "range",
            dateFormat: "m/d/Y",
            onOpen: handle_stayDateOpen,
            onChange: handle_stayDateChange
        };

        if (stay.s_date) {
            if (stay.numNights) {
                const e_date = new Date(stay.s_date.getTime() + days_to_ms(stay.numNights));
                fp_config.defaultDate = [stay.s_date,e_date];
            } else {
                fp_config.defaultDate = [stay.s_date]
            };
        };

        const fp = flatpickr(el, fp_config);
    });
};

export function show_dates_warnings(trip:Trip_v2) {
    let i:number,j:number,k:number;

    const allDates:Array<{type:"stop"|"stay",stopID:string,campID?:number,dates:Date[]}> = []
    for (i = 0; i < trip.legs.length; i++) {
        for (j = 0; j < trip.legs[i].clusters.length; j++) {
            const cluster = trip.legs[i].clusters[j];

            if (!cluster.fromUserQuery) continue;

            let s_date = get_date_ignoreTimezone(cluster.s_date);
            if (cluster.selectedCamps.length == 0 && s_date && cluster.numNights) {
                allDates.push({
                    type: "stop",
                    stopID: cluster.stopID,
                    dates: [s_date, new Date(s_date.getTime() + days_to_ms(cluster.numNights))]
                });
            };
            for (k = 0; k < cluster.selectedCamps.length; k++) {
                if (cluster.selectedCamps[k].s_date && cluster.selectedCamps[k].numNights) {
                    let stay_s_date = get_date_ignoreTimezone(cluster.selectedCamps[k].s_date);
                    allDates.push({
                        type: "stay",
                        stopID: cluster.stopID,
                        dates: [stay_s_date, new Date(stay_s_date.getTime() + days_to_ms(cluster.selectedCamps[k].numNights))],
                        campID: cluster.selectedCamps[k].camp.campID
                    });
                }
            };
        };
    };

    for (i = 0; i < allDates.length - 1; i++) {
        const v = allDates[i], n = allDates[i+1];
        const v_el = v.type == "stop"? $(`[stop-date-warning][stopID="${v.stopID}"]`): $(`[stay-date-warning][stopID="${v.stopID}"][campID="${v.campID}"]`);
        const n_el = n.type == "stop"? $(`[stop-date-warning][stopID="${n.stopID}"]`): $(`[stay-date-warning][stopID="${n.stopID}"][campID="${n.campID}"]`);

        if (v.dates[1].getTime() > n.dates[0].getTime()) {
            //date overlap
            v_el.attr("title", "Date overlap");
            n_el.attr("title", "Date overlap");
            v_el.removeClass("d-none");
            n_el.removeClass("d-none");
        } else if (v.dates[1].getTime() != n.dates[0].getTime()) {
            //date gap
            v_el.attr("title", "Date gap");
            n_el.attr("title", "Date gap");
            v_el.removeClass("d-none");
            n_el.removeClass("d-none");
        } else {
            if (!v_el.hasClass("d-none")) v_el.addClass("d-none");
            if (!n_el.hasClass("d-none")) n_el.addClass("d-none");
        }
    };
};